<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Hesaplama</label>
            <v-select-list :options="options" v-model="sira" label="name" placeholder="Hesaplama"></v-select-list>
        </div>
        <div class="col-12 mb-1" v-if="value.SIRA_NO == '13'">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.agesa">Agesa karşılaştırma dokümanı TMS'ye son bir hafta içinde yüklendi.</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.score">Personel(ler)in ilgili ay için tüm TMS puantajları eksiksiz olarak Puantaj Kaydı sekmesine aktarıldı.</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.kykm">Personel(ler)in ilgili ay için tüm KYKM(avans,icra vs.) girişleri tamamlandı.</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.netsis">Personel(ler)in puantajları Puantaj Kaydı sekmesinden Netsis'e aktarıldı.</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.kykmBrut">Netsis'te KYKM brütleştirme işlemleri tamamlandı.</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.netsisBilgiGiris">Netsis'te puantaj hazırlık bilgi girişi işlemleri tamamlandı.</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox :disabled="value.SIRA_NO == null" v-model="value.order">Yukarıdaki tüm işlemler sırasıyla yapıldı.</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';

export default{
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
    watch:{
        "value.SIRA_NO"(){
            this.value.agesa = false
            this.value.score = false
            this.value.kykm = false
            this.value.netsis = false
            this.value.kykmBrut = false
            this.value.netsisBilgiGiris = false
            this.value.order = false
        }
    },
    data(){
        return{
            options:[
                {name:'BES',value:'13'},
                {name:'İcra',value:'2'}
            ]
        }
    },
    computed:{
        sira:{
            get:function(){
                return this.options.find(s=>s.value == this.value.SIRA_NO)
            },
            set:function(value){
                this.value.SIRA_NO = value?.value || null
            }
        }
    }
}
</script>